import { css } from 'styled-components';

export default css`
  .dark-mode {
    * {
      ::-webkit-scrollbar {
        width: 6px;
        height: 6px;
      }

      /* Track */
      ::-webkit-scrollbar-track {
        background: var(--scrollbar-track-bg);
      }

      /* Handle */
      ::-webkit-scrollbar-thumb {
        background: var(--scrollbar-thumb-bg);
        border-radius: var(--scrollbar-thumb-b-radius);
      }

      /* Handle on hover */
      ::-webkit-scrollbar-thumb:hover {
        background: var(--custom-scrollbar-thumb-bg-hover, var(--scrollbar-track-bg));
      }

      ::-webkit-scrollbar-corner {
        background-color: transparent;
      }
      ::-webkit-scrollbar-track,
      ::-webkit-scrollbar-corner {
        background-color: transparent;
      }
    }
  }

  .light-mode {
    * {
      ::-webkit-scrollbar {
        width: 6px;
        height: 6px;
      }

      /* Track */
      ::-webkit-scrollbar-track {
        background: var(--scrollbar-track-bg);
      }

      /* Handle */
      ::-webkit-scrollbar-thumb {
        background: var(--scrollbar-thumb-bg);
        border-radius: var(--scrollbar-thumb-b-radius);
      }

      /* Handle on hover */
      ::-webkit-scrollbar-thumb:hover {
      }

      ::-webkit-scrollbar-corner {
        background-color: transparent;
      }
      ::-webkit-scrollbar-track,
      ::-webkit-scrollbar-corner {
        background-color: transparent;
      }
    }
  }
`;
